<template>
  <div class="bg-racq-anti-flash-white min-h-[100svh] md:flex justify-evenly">
    <div class="bg-white mx-auto md:my-auto md:rounded-xl shadow-xl">
      <div class="max-w-[456px] px-4 py-8 border-b flex justify-center">
        <img src="@/assets/racq-logo.svg" alt="RACQ Logo" width="119" height="30" />
      </div>
      <div class="max-w-[456px] px-12 pt-8 pb-12"><slot name="body"></slot></div>
      <div class="max-w-[456px] px-12 py-8 border-t"><slot name="disclaimer"></slot></div>
    </div>
  </div>
</template>
